import { createContext } from '@lit/context'
import { ItemData } from './contextual-one-ux-menu/types'

export interface IMenuContext {
  items: ItemData[]
}

export const menuContext = createContext<IMenuContext>('menuContext')
